import { Component, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { MergePatientService } from '../merge-patient.service';
import { AppConfigService } from '@app/common/app-config.service';
import { DataTransformationService } from '@app/common/data-transformation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-patient-view',
  templateUrl: './patient-view.component.html',
  styleUrls: ['./patient-view.component.scss']
})
export class PatientViewComponent {
  @Input() item: any;
  @Input() showHeader = false;
  @Input() headerTitle;
  @Output() manageSwapVisibility = new EventEmitter<boolean>();
  exams: any;
  dateTimePref = {} as any;
  patientAge: any;
  private uvDateTimeSubscriber: Subscription;

  constructor(
    private mergePatientService: MergePatientService,
    private cd: ChangeDetectorRef,
    private appConfigService: AppConfigService,
    private dataTransformationService: DataTransformationService
  ) {}

  ngOnChanges() {
    this.getSelectedPatientExams();
  }

  ngOnInit(): void {
    this.dateTimePref = this.appConfigService.getDateTimePref();
    this.uvDateTimeSubscriber = this.appConfigService.getDateTimeObserver().subscribe(value => {
      this.dateTimePref = value;
      this.cd.detectChanges();
    });
    this.patientAge = this.dataTransformationService.calculateStudyAge(this.item.birthDate, Date.now());
  }

  ngOnDestroy(): void {
    this.uvDateTimeSubscriber.unsubscribe();
  }

  getSelectedPatientExams() {
    const pid = this.getPid();
    let enableSwap = true;
    if (pid) {
      this.mergePatientService.getPatientExams(pid).then((data: any[]) => {
        this.exams = [...data];
        if (this.exams.length === 0) {
          enableSwap = false;
        }
        this.manageSwapVisibility.emit(enableSwap);
        this.cd.detectChanges();
      });
    }
  }

  getPid() {
    const unavailable = 'Unavailable';
    let pid = this.item.pid;
    if (pid === unavailable && this.item.mrn.otherDomainIdentifierList.length > 0) {
      pid = this.item.mrn.otherDomainIdentifierList[0].value;
    }
    return pid;
  }
}
